/* global FCMPlugin, facebookConnectPlugin, Camera, admob */

var cordovaApp = {
  f7: null,
  /*
   This method hides splashscreen after 2 seconds
   */
  handleSplashscreen: function () {
    var f7 = cordovaApp.f7;
    if (!window.navigator.splashscreen || f7.device.electron)
      return;
    setTimeout(() => {
      window.navigator.splashscreen.hide();
    }, 2000);
  },
  /*
   This method prevents back button tap to exit from app on android.
   In case there is an opened modal it will close that modal instead.
   In case there is a current view with navigation history, it will go back instead.
   */
  handleAndroidBackButton: function () {
    var f7 = cordovaApp.f7;
    const $ = f7.$;
    if (f7.device.electron)
      return;
    document.addEventListener('backbutton', function (e) {
      if ($('.actions-modal.modal-in').length) {
        f7.actions.close('.actions-modal.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.dialog.modal-in').length) {
        f7.dialog.close('.dialog.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.sheet-modal.modal-in').length) {
        f7.sheet.close('.sheet-modal.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.popover.modal-in').length) {
        f7.popover.close('.popover.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.popup.modal-in').length) {
        if ($('.popup.modal-in>.view').length) {
          const currentView = f7.views.get('.popup.modal-in>.view');
          if (currentView && currentView.router && currentView.router.history.length > 1) {
            currentView.router.back();
            e.preventDefault();
            return false;
          }
        }
        f7.popup.close('.popup.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.login-screen.modal-in').length) {
        f7.loginScreen.close('.login-screen.modal-in');
        e.preventDefault();
        return false;
      }

      if ($('.page-current .searchbar-enabled').length) {
        f7.searchbar.disable('.page-current .searchbar-enabled');
        e.preventDefault();
        return false;
      }

      if ($('.page-current .card-expandable.card-opened').length) {
        f7.card.close('.page-current .card-expandable.card-opened');
        e.preventDefault();
        return false;
      }

      const currentView = f7.views.current;
      if (currentView && currentView.router && currentView.router.history.length > 1) {
        currentView.router.back();
        e.preventDefault();
        return false;
      }

      if ($('.panel.panel-in').length) {
        f7.panel.close('.panel.panel-in');
        e.preventDefault();
        return false;
      }
    }, false);
  },
  /*
   This method does the following:
   - provides cross-platform view "shrinking" on keyboard open/close
   - hides keyboard accessory bar for all inputs except where it required
   */
  handleKeyboard: function () {
    var f7 = cordovaApp.f7;
    if (!window.Keyboard || !window.Keyboard.shrinkView || f7.device.electron)
      return;
    var $ = f7.$;
    window.Keyboard.shrinkView(false);
    window.Keyboard.disableScrollingInShrinkView(true);
    window.Keyboard.hideFormAccessoryBar(true);
    window.addEventListener('keyboardWillShow', () => {
      f7.input.scrollIntoView(document.activeElement, 0, true, true);
    });
    window.addEventListener('keyboardDidShow', () => {
      f7.input.scrollIntoView(document.activeElement, 0, true, true);
    });
    window.addEventListener('keyboardDidHide', () => {
      if (document.activeElement && $(document.activeElement).parents('.messagebar').length) {
        return;
      }
      window.Keyboard.hideFormAccessoryBar(false);
    });
    window.addEventListener('keyboardHeightWillChange', (event) => {
      var keyboardHeight = event.keyboardHeight;
      if (keyboardHeight > 0) {
        // Keyboard is going to be opened
        document.body.style.height = `calc(100% - ${keyboardHeight}px)`;
        $('html').addClass('device-with-keyboard');
      }
      else {
        // Keyboard is going to be closed
        document.body.style.height = '';
        $('html').removeClass('device-with-keyboard');
      }

    });
    $(document).on('touchstart', 'input, textarea, select', function (e) {
      var nodeName = e.target.nodeName.toLowerCase();
      var type = e.target.type;
      var showForTypes = ['datetime-local', 'time', 'date', 'datetime'];
      if (nodeName === 'select' || showForTypes.indexOf(type) >= 0) {
        window.Keyboard.hideFormAccessoryBar(false);
      }
      else {
        window.Keyboard.hideFormAccessoryBar(true);
      }
    }, true);
  },
  FCM() {

    FCM.requestPushPermission({
      ios9Support: {
        timeout: 10, // How long it will wait for a decision from the user before returning `false`
        interval: 0.3 // How long between each permission verification
      }
    })
      .then(res => console.log(res))
      .catch(err => console.log(err));


    // cordova plugin add cordova-plugin-fcm-with-dependecy-updated
    FCM.getToken().then(token => {
      console.log('FCM Token: ' + token);
      myApp.server.put('imc/fcmtoken', {token: token, uid: myApp.uid})
        .then(resp => {
          if (resp.uid != myApp.uid) {
            myApp.uid = resp.uid;
            localStorage.uid = resp.uid;
          }
        });
    });

    FCM.onNotification((data) => {
      if (data.wasTapped) {
        //Notification was received on device tray and tapped by the user.
        console.log(JSON.stringify(data));
      }
      else {
        //Notification was received in foreground. Maybe the user needs to be notified.
        console.log(JSON.stringify(data));
        // Display notification
        const notification = cordovaApp.f7.notification.create({
          icon: data.media || '<img src="static/icon-512.png" class="responsive"/>',
          title: data.title,
          titleRightText: new Date().toLocaleString(),
          subtitle: data.subtitle || '',
          text: data.body,
          closeOnClick: false,
          closeTimeout: 3000,
          on: {
            close: function () {
              cordovaApp.f7.notification.destroy(notification);
            },
            click: function () {
              // ...
            }
          }
        }).open();
      }
    });

    FCM.onTokenRefresh((token) => {
      myApp.server.put('imc/fcmtoken', {token: token, uid: myApp.uid})
        .then(resp => {
          if (resp.uid != myApp.uid) {
            myApp.uid = resp.uid;
            localStorage.uid = resp.uid;
          }
        });
    });

  },
  facebookLogin: function () {
    return new Promise((resolve, reject) => {
      const fbLoginSuccess = function (userData) {
        console.log('fbLoginSuccess');
        fbGetData(userData);
      };
      const fbLoginError = function (error) {
        console.log('fbLogin Error', error);
      };
      const fbGetData = function (userData) {
        console.log('fbGetData');
        const qs = userData.authResponse.userID +
          '/?fields=id,email,name,short_name,last_name,picture.width(900).height(900)';
        const auth = ["public_profile", "email"];
        facebookConnectPlugin.api(qs, auth, fbGetDataSuccess, fbGetDataError);
      };
      const fbGetDataSuccess = function (result) {
        console.log('fbGetDataSuccess');
        fbSignIn(result);
      };
      const fbGetDataError = function (error) {
        console.log('fbGetDataError');
        reject(error);
      };
      const fbSignIn = function (user) {
        myApp.server.post('imc/fblogin', user).then(resp => {
          resolve(resp);
        }).catch(err => {
          reject(err);
        });
      };
      facebookConnectPlugin.login(["public_profile", "email"], fbLoginSuccess, fbLoginError);
    });
  },
  appleLogin: function () {
    return new Promise((resolve, reject) => {
      window.cordova.plugins.SignInWithApple.signin(
        {requestedScopes: [0, 1]},
        function (user) {
          console.log('appleLogin Success');
          /*
           * Attenzione!!! Tutti i campi possono essere vuoti, tranne "user"
           * 
           * {
           * "email":"info@studiolovotrico.net",
           * "authorizationCode":"c98849cb8177e49a396eb42e64c6a46bb.0.mrvyv.3EtXPVcRFTuf5Ehroaf6iA",
           * "state":"",
           * "identityToken":"<identityToken>",
           * "fullName":{
           *    "nickname":"",
           *    "phoneticRepresentation":{},
           *    "middleName":"",
           *    "familyName":"Lovotrico",
           *    "namePrefix":"",
           *    "givenName":"Guillermo",
           *    "nameSuffix":""
           *    },
           * "user":"001585.c7a9e693f5974b2f96bc60487a13a51f.1515"
           * }
           */
          myApp.server.post('imc/applelogin', user).then(res => {
            resolve(res);
          }).then(err => {
            reject(err);
          });
        },
        function (err) {
          console.error('appleLogin Error');
          // Gestione dell'errore
          reject(err);
        }
      );
    });
  },
  googleLogin: function () {
    /*
     * PATCH: Inappbrowser change useragent
     * 
     * Nei file
     * <root project>/cordova/platforms/ios/InfoMyLove/Plugins/cordova-plugin-inappbrowser/CDVUIInAppBrowser.m
     * <root project>/cordova/platforms/ios/InfoMyLove/Plugins/cordova-plugin-inappbrowser/CDVWKInAppBrowser.m
     * <root project>/cordova/platforms/android/app/src/main/java/org/apache/cordova/inappbrowser/InAppBrowser.java
     * 
     * Sostituire la stringa
     * "OverrideUserAgent" con "InAppBrowserOverrideUserAgent"
     * 
     * Nel file /config.xml inserire:
     * <preference name="InAppBrowserOverrideUserAgent" value="Mozilla/5.0" />
     * Oppure esteso
     * <preference name="InAppBrowserOverrideUserAgent" value="Mozilla/5.0 (iPhone; CPU iPhone OS 12_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/75.0.3770.85 Mobile/15E148 Safari/605.1" />
     */
    const server = myApp.server;
    return new Promise((resolve, reject) => {
      // 1) chiede al server un token
      server.get('auth/google/')
        .then(result => {
          if (!result.success) {
            return reject(result);
          }
          // apre una finestra di InAppBrowser
          const url = 'https://dreamgest.com/infomycity-auth/' + result.token;
          const opt = 'location=no,toolbarcolor=#ffffff,closebuttoncolor=#007aff' +
            ',hardwareback=no,hidenavigationbuttons=yes,zoom=no';
          const ref = cordova.InAppBrowser.open(url, '_blank', opt);
          // cattura evento 'close'
          ref.addEventListener('loadstart', function (event) {
            console.log('event.url: ' + event.url);
            if (event.url.match("close")) {
              ref.close();
            }
          });
          // cattura errore
          ref.addEventListener('loaderror', function (params) {
            const scriptErrorMesssage = "alert('Sorry we cannot open that page. Message from the server is : "
              + params.message + "');";
            ref.executeScript({code: scriptErrorMesssage}, function () {});
            ref.close();
            ref = undefined;
          });
          // cattura evento di chiusura
          ref.addEventListener('exit', function () {
            // recupera dal server lo stato di autenticazione
            server.get('auth/google/' + result.token)
              .then(g => {
                console.log(g, '[GET] auth/google/' + result.token);
                // {"success":true,"me":{"short_name":"Guillermo","last_name":"Lovotrico","email":"g.lovotrico@gmail.com","picture":{"data":{"url":"https://lh3.googleusercontent.com/a-/AOh14Ggv_2_uJmuwm4fDRn23SoBgujOf-eOiyMIq6fNrRno"}}},"signUpComplete":false} 
                return myApp.server.post('imc/googlelogin', g.me);
              })
              .then(succ => {
                resolve(succ);
              })
              .catch(err => {
                reject(err);
              });
          });
        });
    });
  },
  cameraAvatar: function (gallery) {
    return new Promise((resolve, reject) => {
      const success = function (imageURI) {
        resolve('data:image/jpeg;base64,' + imageURI);
      };
      const error = function (error) {
        reject(error);
      };
      const options = {
        quality: 85,
        destinationType: Camera.DestinationType.DATA_URL,
        sourceType: (gallery === 'gallery') ? Camera.PictureSourceType.PHOTOLIBRARY : Camera.PictureSourceType.CAMERA,
        targetWidth: 450,
        targetHeight: 450,
        cameraDirection: Camera.Direction.FRONT,
        correctOrientation: true,
        allowEdit: true
      };
      navigator.camera.getPicture(success, error, options);
    });
  },
  camera: function (gallery) {
    return new Promise((resolve, reject) => {
      const success = function (imageURI) {
        resolve('data:image/jpeg;base64,' + imageURI);
      };
      const error = function (error) {
        reject(error);
      };
      const options = {
        quality: 85,
        destinationType: Camera.DestinationType.DATA_URL,
        sourceType: (gallery === 'gallery') ? Camera.PictureSourceType.PHOTOLIBRARY : Camera.PictureSourceType.CAMERA,
        targetWidth: 700,
        targetHeight: 700,
        //cameraDirection: Camera.Direction.FRONT,
        correctOrientation: true,
        //allowEdit: true
      };
      navigator.camera.getPicture(success, error, options);
    });
  },
  videoGallery: function (id) {
    /*
     * In CDVCamera.m sustituire 
     - (CDVPluginResult*)resultForVideo:(NSDictionary*)info
     {
     NSString* moviePath = [[info objectForKey:UIImagePickerControllerMediaURL] absoluteString];
     return [CDVPluginResult resultWithStatus:CDVCommandStatus_OK messageAsString:moviePath];
     } 
     con: 
     - (CDVPluginResult*)resultForVideo:(NSDictionary*)info
     {
     NSString* moviePath = [[info objectForKey:UIImagePickerControllerMediaURL] path];
     
     NSArray* spliteArray = [moviePath componentsSeparatedByString: @"/"];
     NSString* lastString = [spliteArray lastObject];
     NSError *error;
     NSFileManager *fileManager = [NSFileManager defaultManager];
     NSString *documentsDirectory = [NSHomeDirectory() stringByAppendingPathComponent:@"tmp"];
     NSString *filePath = [documentsDirectory stringByAppendingPathComponent:lastString];
     [fileManager copyItemAtPath:moviePath toPath:filePath error:&error];
     
     return [CDVPluginResult resultWithStatus:CDVCommandStatus_OK messageAsString:filePath];
     }  
     */
    return new Promise((resolve, reject) => {
      var success = function (imageURI) {
        const mediaFile = {
          fullPath: imageURI,
          name: id,
          type: 'video/*',
        };
        resolve(mediaFile);
      };
      var error = function (error) {
        reject(error);
      };
      var options = {
        sourceType: Camera.PictureSourceType.PHOTOLIBRARY,
        mediaType: Camera.MediaType.VIDEO,
        destinationType: Camera.DestinationType.FILE_URI
      };
      navigator.camera.getPicture(success, error, options);
    });
  },
  // Upload files to server
  uploadFile: function (mediaFile) {
    // file transfer
    return new Promise((resolve, reject) => {
      const id = new Date().getTime().toString() + Math.floor(Math.random() * 1000);
      const ft = new FileTransfer(),
        path = mediaFile.fullPath,
        name = mediaFile.name,
        type = mediaFile.type;
      ft.upload(path, "https://rest.dreamgest.com/infomycity/videos/" + id, function (success) {
        const data = JSON.parse(success.response);
        console.log(data);
        resolve(data.url);
      }, function (error) {
        console.log(error);
        reject(error);
      }, {
        fileName: name,
        mimeType: type,
        chunkedMode: false,
        headers: {
          Connection: "close"
        }, params: {
          imc: true,
          appId: myApp.server.applicationId,
          authToken: localStorage.token
        }
      });
    });
  },
  uploadAudio: function (mediaFile) {
    // file transfer
    return new Promise((resolve, reject) => {
      const id = new Date().getTime().toString() + Math.floor(Math.random() * 1000);
      const ft = new FileTransfer(),
        path = mediaFile.fullPath,
        name = mediaFile.name,
        type = mediaFile.type;
      ft.upload(path, "https://rest.dreamgest.com/infomycity/audio/" + id, function (success) {
        const data = JSON.parse(success.response);
        console.log(data);
        resolve(data.src);
      }, function (error) {
        console.log(error);
        reject(error);
      }, {
        fileName: name,
        mimeType: type,
        chunkedMode: false,
        headers: {
          Connection: "close"
        }, params: {
          imc: true,
          appId: myApp.server.applicationId,
          authToken: localStorage.token
        }
      });
    });
  },
  captureVideo: function () {
    const MAX_DURATION = 60;
    return new Promise((resolve, reject) => {
      const captureSuccess = function (mediaFiles) {
        resolve(mediaFiles[0]);
      };
      const captureError = function (error) {
        reject(error);
      };
      const captureOptions = {limit: 1, duration: MAX_DURATION, quality: 0};
      navigator.device.capture.captureVideo(captureSuccess, captureError, captureOptions);
    });
  },
  captureAudio: function () {
    const MAX_DURATION = 60;
    return new Promise((resolve, reject) => {
      const captureSuccess = function (mediaFiles) {
        resolve(mediaFiles[0]);
      };
      const captureError = function (error) {
        reject(error);
      };
      const captureOptions = {limit: 1, duration: MAX_DURATION};
      navigator.device.capture.captureAudio(captureSuccess, captureError, captureOptions);
    });
  },
  socialShare(type) {
    const f7 = cordovaApp.f7;
    const $ = f7.$;
    const l = lng.language;
    const message = (type == 'friend' ? myApp.messages[l].inviteFriendMsg : myApp.messages[l].invitePOIMsg) || '';
    const php = (type == 'friend' ? 'invite_friend.php' : 'invite_poi.php');
    // this is the complete list of currently supported params you can pass to the plugin (all optional)
    var options = {
      message: message.replace('%code%', myApp.user.client_code), // not supported on some apps (Facebook, Instagram)
      subject: myApp.messages[l].inviteFriendSubject || '', // fi. for email
      //files: ['', ''], // an array of filenames either locally or remotely
      url: 'https://rest.dreamgest.com/infomycity/' + php + '?u=' + myApp.user.client_code + '&l=' + l,
      chooserTitle: lng.inviteAFriend, // Android only, you can override the default share sheet title
      //appPackageName: 'com.apple.social.facebook', // Android only, you can provide id of the App you want to share with
      //iPadCoordinates: '0,0,0,0' //IOS only iPadCoordinates for where the popover should be point.  Format with x,y,width,height
    };
    var onSuccess = function (result) {
      console.log("Share completed? " + result.completed); // On Android apps mostly return false even while it's true
      console.log("Shared to app: " + result.app); // On Android result.app since plugin version 5.4.0 this is no longer empty. On iOS it's empty when sharing is cancelled (result.completed=false)

      // reimposta dimensione viewport
      window.location.reload();
    };
    var onError = function (msg) {
      console.log("Sharing failed with message: " + msg);
      window.location.reload();
    };
    window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
  },
  adMob() {
    /*
     cordova plugin add cordova-admob-plus \
     --variable APP_ID_ANDROID=ca-app-pub-3132186059130534~1313358778 \
     --variable APP_ID_IOS=ca-app-pub-3132186059130534~4109739044
     */
    const ids = {
      android: {
        idApp: 'ca-app-pub-3132186059130534~1313358778',
        banner: 'ca-app-pub-3132186059130534/3750468783',
      },
      iOS: {
        idApp: 'ca-app-pub-3132186059130534~4109739044',
        banner: 'ca-app-pub-3132186059130534/1539238413',
      }
    };

    admob.banner.show({
      id: {
        // replace with your ad unit IDs
        android: ids.android.banner,
        ios: ids.iOS.banner,
      },
    });

  },
  init: function (f7) {
    // Save f7 instance
    cordovaApp.f7 = f7;
    // Handle Android back button
    cordovaApp.handleAndroidBackButton();
    // Handle Splash Screen
    cordovaApp.handleSplashscreen();
    // Handle Keyboard
    cordovaApp.handleKeyboard();
    // FCM
    cordovaApp.FCM();
    // adMob
    cordovaApp.adMob();
    // geolocation
    navigator.geolocation.getCurrentPosition(res => {
      myApp.latlng = [res.coords.latitude, res.coords.longitude];
    }, err => {
      console.log('Error geolocation: ' + err.message);
    });
  },
};
export default cordovaApp;
